import React, { PureComponent } from 'react';
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import './success.css';
import successIcon from 'images/successIcon.png';
import GlobalHeader from 'components/GlobalHeader'
import GlobalFooter from 'components/GlobalFooter'
import { Message } from 'element-react';
import { Link } from 'react-router-dom';

export default class ResetPassword extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            phone: ''
        }

    }

    componentWillMount() {
        // 当前页刷新时获取路由参数值
        var search = this.props.location.search;
        var index = search.lastIndexOf("\=");
        var searchVal = search.substring(index + 1, search.length);
        console.log(searchVal);
        this.setState({ phone: searchVal })
    }

    goLogin() {
        this.props.history.replace("/login");
    }


    render() {
        return (
            <div>
                <GlobalHeader history={this.props.history} />
                <div className="main_success">
                    {/* {this.renderLIst()} */}

                    {/* {内容区域*/}
                    <div className="center">
                        <div className="content">
                            <div className="content_box_success">
                                <div className="content_box_title">帐号安全</div>
                                <div className="content_box_success_find">找回密码</div>
                                <div className><img src={successIcon} style={{ margin: '0 8px -4px 0' }}></img>恭喜，退役军人帐号<span style={{ color: '#10B813' }}>{this.state.phone}</span>重置密码成功</div>
                                <div className="content_box_login" onClick={this.goLogin.bind(this)}><span>直接登录</span></div>
                            </div>
                        </div>
                    </div>

                    {/*内容区域} */}

                    <GlobalFooter />
                </div>
            </div>
        )
    }
}